import { differenceInDays, differenceInMonths, isBefore } from "date-fns";
import { parseDateString } from "Helpers/dateTime";
import { UserEncoreStatus, UserEncoreTiers } from "Helpers/users";
import { EncorePackageProps, EncorePackagePaymentStatus } from "Types/vehicle";

const EXPIRING_MONTHS_THRESHOLD = 3;
const EXPIRING_DAYS_THRESHOLD = 5;

export const isDateExpired = (packageExpiryDate?: string) => {
    if (!packageExpiryDate) return true;

    const expiryDate = parseDateString(packageExpiryDate);

    if (!expiryDate) return true;

    return isBefore(expiryDate, new Date());
};

export const isExpiredWithinDaysThreshold = (date: string): boolean => {
    if (!date) return false;
    const today = new Date();
    const targetDate = parseDateString(date);

    if (!targetDate) {
        return false;
    }

    const daysSinceExpiry = differenceInDays(today, targetDate);

    return daysSinceExpiry <= EXPIRING_DAYS_THRESHOLD && daysSinceExpiry >= 0;
};

export const getPackageStatus = (encorePackage: EncorePackageProps) => {
    const currentDate = new Date();
    const expiryDate = encorePackage.packageExpiryDate ? parseDateString(encorePackage.packageExpiryDate) : null;
    const gapInMonths = expiryDate ? differenceInMonths(expiryDate, currentDate) : null;
    const isExpired = isDateExpired(encorePackage.packageExpiryDate);
    const isActive = Boolean(gapInMonths && gapInMonths >= EXPIRING_MONTHS_THRESHOLD);

    const encoreTier = encorePackage.encoreTier;

    if (isExpired) {
        return UserEncoreStatus.EXPIRED;
    }

    if (!isActive) {
        return UserEncoreStatus.EXPIRING_SOON;
    }

    if (encorePackage.packagePaymentStatus === EncorePackagePaymentStatus.PaymentPending) {
        return UserEncoreStatus.START_UPGRADE;
    }

    if (
        encoreTier === UserEncoreTiers.ELEVATE &&
        encorePackage.packagePaymentStatus === EncorePackagePaymentStatus.PaymentCompleted
    ) {
        return UserEncoreStatus.RENEWAL_SUCCESSFUL;
    }
    return UserEncoreStatus.ACTIVE;
};
